import { createExternalStore } from "@nova/toolkit-pure-hooks"
import { EventModel } from "@nova/db-table-live-video"

export type UserLocationShareTelemetryEvent = EventModel & { type: "locationShare" }

export type UserLocationSharePlaybackState = {
    path: UserLocationShareTelemetryEvent[]
    current: UserLocationShareTelemetryEvent
    isPlaying: boolean
}

export const userLocationSharePlaybackStore = createExternalStore<UserLocationSharePlaybackState>()
